import React from 'react';
import { Box, Button, Typography } from '@mui/material';
import InboxRoundedIcon from '@mui/icons-material/InboxRounded';
import { alpha, useTheme } from '@mui/material/styles';

export default function EmptyState({
  title = 'No results found',
  description = 'Try adjusting your filters or create a new record.',
  actionLabel,
  onAction,
  icon,
  compact = false,
}) {
  const theme = useTheme();
  const Icon = icon || InboxRoundedIcon;

  return (
    <Box
      sx={{
        minHeight: compact ? 140 : 220,
        borderRadius: 2.5,
        border: '1px dashed',
        borderColor: 'divider',
        backgroundColor:
          theme.palette.mode === 'dark'
            ? alpha(theme.palette.background.paper, 0.76)
            : alpha(theme.palette.background.paper, 0.95),
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'center',
        justifyContent: 'center',
        gap: 1.15,
        px: 2.5,
        py: compact ? 2.25 : 4.5,
        textAlign: 'center',
      }}
    >
      <Icon
        sx={{
          fontSize: compact ? 26 : 36,
          color: 'text.secondary',
          p: 0.6,
          borderRadius: 2,
          backgroundColor: 'action.hover',
        }}
      />
      <Typography variant="subtitle1" sx={{ fontWeight: 800 }}>
        {title}
      </Typography>
      <Typography variant="body2" color="text.secondary" sx={{ maxWidth: 460 }}>
        {description}
      </Typography>
      {actionLabel && onAction ? (
        <Button variant="contained" size="small" onClick={onAction} sx={{ mt: 0.6 }}>
          {actionLabel}
        </Button>
      ) : null}
    </Box>
  );
}

